module.exports = __webpack_public_path__ + "img/telefono.91e83459.svg";